import React from 'react';
import styled from 'styled-components';
import cyber from '../../Asset/img/cyber.png';
import social from '../../Asset/img/social.png';
import design from '../../Asset/img/design.jpg';
import web from '../../Asset/img/web.png';
const Header = () => {
  return (
    <HeaderWrapper>
      <LeftWrapper>
        <LeftContent>
          <h1>
            Providing <br /> Digital Space <br /> For
            Your Business
          </h1>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Laborum,
            maxime amet numquam quaerat quasi ab exercitationem nostrum
            dignissimos asperiores repellendus?
          </p>
          <div className="hero-btn">
            <button type="button">Read More</button>
            <button type="button">Learn More</button>
          </div>
        </LeftContent>
      </LeftWrapper>
      <RightWrapper>
        <RightContent>
          <div className="container">
            <span>
              <p>Cyber Assistance</p>
            </span>
            <img src={cyber} alt="IT Solution" />
          </div>
          <div className="container">
            <span>
              <p>Website Design</p>
            </span>
            <img src={design} alt="web designing" />
          </div>
          <div className="container">
            <span>
              <p>Digital Marketing</p>
            </span>
            <img src={social} alt="digital marketing" />
          </div>
          <div className="container">
            <span>
              <p>Website</p>
            </span>
            <img src={web} alt="website development" />
          </div>
        </RightContent>
      </RightWrapper>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.section`
  background: linear-gradient(to left bottom, #fff, var(--bga-color));
  display: grid;
  grid-template-columns: 65% 33%;
  gap: 2%;
  min-height: 100vh;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5%;
  @media screen and (max-width: 884px) {
   grid-template-columns: 1fr 1fr;
   min-height: 70vh;
   padding-top: 8rem;
  }
  @media screen and (max-width: 768px) {
   grid-template-columns: 100%;
   min-height: 120vh;
   padding-top: 8rem;
  }
  @media screen and (max-width: 430px) {
   grid-template-columns: 100%;
   min-height: 120vh;
   padding-top: 8rem;
  }
`;

const LeftWrapper = styled.article`
  transform: translateY(5.5rem);
  @media screen and (max-width: 768px) {
   transform: translate(0);
  }
  @media screen and (max-width: 430px) {
   transform: translate(0);
  }
`;

const LeftContent = styled.div`
  h1 {
    color: var(--bg-color);
    font-size: 3rem;
  }
  p {
    font-size: 1.06;
    font-weight: 600;
    line-height: 1.7;
    padding: 15px 0;
    max-width: 520px;
  }

  .hero-btn {
    padding-top: 15px;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    button {
      background: var(--main-color);
      border-radius: 50px;
      box-shadow: 0 0.3rem 1rem rgb(0 0 0 / 20%);
      cursor: pointer;
      font-size: 1.04rem;
      font-weight: 600;
      width: 25%;
      padding: 12px;
      transition: all 1000ms ease-in-out;

      :nth-child(1) {
        background: var(--main-color);
        border-left: solid var(--bg-color);
        color: var(--bg-color);
        &:hover {
          background: var(--bg-color);
          color: var(--main-color);
          text-align: center;
        }
      }

      :nth-child(2) {
        background: var(--bg-color);
        border-left: solid var(--main-color);
        color: var(--main-color);
        &:hover {
          background: var(--main-color);
          color: var(--bg-color);
          text-align: center;
        }
      }
    }
  }

  @media screen and (max-width: 884px) {
   h1{
    font-size: 3rem;
   }
   p{
    font-weight: 400;
   }
   .hero-btn{
    button{
      width: 50%;
    }
   }
  }

  @media screen and (max-width: 768px) {
   .hero-btn{
    button{
      width: 35%;
    }
   }
  }

  @media screen and (max-width: 430px) {
   h1{
    font-size: 2.2rem;
   }
   p{
    font-weight: 400;
   }
   .hero-btn{
    button{
      width: 50%;
    }
   }
  }

  @media screen and (max-width: 360px) {
   .hero-btn{
    :nth-child(2){
      &:hover{
       border-left-width: 0;
      }
    }
   }
  }
`;

const RightWrapper = styled.article`
  background: linear-gradient(-135deg, var(--bga-color), var(--main-color));
  box-shadow: 0 0.5rem 1rem rgba(255, 0, 0, 0.034);
  border-radius: 0.2rem;
  height: 90%;
  @media screen and (max-width: 884px) {
   height: 60%;
  }
  @media screen and (max-width: 430px) {
   height: 65vh;
  }
`;

const RightContent = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 1rem;
  height: 85%;
  transform: translate(-5rem, 2.5rem);

  .container {
    position: relative;
    background: rgb(255 255 255);
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    border-radius: 0.2rem;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 2s ease-in-out;
    img {
      width: 100%;
    }

    span {
      background: var(--bg-color);
      border-radius: 50px;
      color: var(--main-color);
      position: absolute;
      top: 10px;
      right: 1rem;
      padding: 3px 8px;
      width: 55%;
      p {
        font-size: 10px;
        font-weight: 600;
        text-align: center;
      }
    }

    &:hover {
      background: rgb(255 255 255 / 85%);
    }
  }

  @media screen and (max-width: 884px) {
   transform: translate(-10px, 10px);
   width: 100%;
   height: 50vh;
  }

  @media screen and (max-width: 768px) {
   transform: translate(-10px, 10px);
   width: 100%;
  }

  @media screen and (max-width: 430px) {
   transform: translate(-10px, 1.5rem);
   width: 100%;
   height: 60vh;
   .container{
    span{
      width: 80%;
    }
   }
  }

  @media screen and (max-width: 360px) {
   transform: translate(-10px, 10px);
   width: 100%;

   .container{
    span{
      width: 80%;
    }
   }
  }
`;

export default Header;
